import { Box, Typography } from '@mui/material';

export const NoDataMessage = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '300px',
      textAlign: 'center',
      color: 'text.secondary',
      flex: 1
    }}
  >
    <Typography variant='body1'>
      No data available for the selected date range. Try adjusting it.
    </Typography>
  </Box>
);
